import { AggregateDescriptor, CompositeFilterDescriptor, FilterDescriptor, isCompositeFilterDescriptor } from "@progress/kendo-data-query";
import { storageStatisticsGridColumnItems } from "../GridColumns";

export const footerItemsField = [
    // { field: "grossWeight", sum: 0.00 , hasFilter: true },
    { field: "quantity", sum: 0.00, hasFilter: true },
    { field: "numberOfUnits", sum: 0.00 , hasFilter: true },
    { field: "roundWeight", sum: 0.00, hasFilter: true },
];

const baseAggregateFields: AggregateDescriptor[] = footerItemsField.map((item) => ({ 
    field: item.field, 
    aggregate: "sum" 
}));

const weigghtAggregateFields: AggregateDescriptor[] = [
    { field: "grossWeight", aggregate: "max" },
    { field: "grossWeight", aggregate: "min" },
    { field: "grossWeight", aggregate: "average" },
    { field: "grossWeight", aggregate: "sum" }
];

const aggregatesFields: AggregateDescriptor[] = [ ...baseAggregateFields, ...weigghtAggregateFields ];

const handleFilteredItem = (
    filters: CompositeFilterDescriptor
): { field: string; values: any[] }[] => {
    const clonedFilters: CompositeFilterDescriptor = JSON.parse(JSON.stringify(filters));
    const result: { field: string; values: any[] }[] = [];

    const processFilter = (filter: FilterDescriptor | CompositeFilterDescriptor) => {
        if (isCompositeFilterDescriptor(filter)) {
            (filter as CompositeFilterDescriptor).filters.forEach((f) => processFilter(f));
        } else {
            const singleFilter: FilterDescriptor = { ...filter } as FilterDescriptor;
            const columns = storageStatisticsGridColumnItems({ ref: { current: null }, data: [], filteredDataRef: { current: [] } });
            const column = columns.find(col => col.field === singleFilter.field);
            
            if (column?.title) {
                singleFilter.field = column.title.toString();
            }
            
            if (!singleFilter.field || typeof singleFilter.field !== "string") {
                return;
            }
            
            const existingItem = result.find((r) => r.field === singleFilter.field);
            if (existingItem) {
                existingItem.values.push(singleFilter.value);
            } else {
                result.push({ field: singleFilter.field, values: [singleFilter.value] });
            }
        }
    };

    clonedFilters.filters.forEach((f) => processFilter(f));
    return result;
};

export { handleFilteredItem, aggregatesFields };
